export class FormV3Scripts {
   /**
    * Get field constraint (attribute) value
    * @param {object} fieldObject - field object from java api
    * @param {string} constraint - field attribute name: ("required", "NotInsertable", etc...)
    * @returns {*} - attribute value
    */
   static getFieldAttribute = (fieldObject, constraint) => {
      // THIS FUNCTION NEEDS TO BE CHANGED WE WONT USE CONSTRAINTS ANYMORE WE WILL USE DECORATORS
      return fieldObject?.modelField?.constraints?.includes(constraint);
   };
}

export const hiddenFieldStyles = {
   visibility: "hidden",
   position: "absolute",
   cursor: "default"
};
